export const deviationI18n = {
  deviation: {
    en: {
      ACTUAL_CONSEQUENCES: 'Actual consequences',
      ACTUAL_CONSEQUENCES_DESCRIPTION: 'Description of actual consequences',
      ADD_MEASURE: 'Add measure',
      ADDED: 'Added',
      AFFECTED_CLIENTS: 'Affected clients',
      AFFECTED_FOSTER_FAMILIES: 'Affected foster families',
      AFFECTED_STAFF: 'Affected staff',
      ARE_YOU_SURE_WANT_TO_DELETE: 'Are you sure want to delete?',
      ASSESSMENT: 'Assessment',
      ASSESSMENT_AND_DECISION: 'Assessment and decision on action',
      ASSESSMENT_OF_INVESTIGATED_REPORT: 'Assessment of investigated report',
      BASIC_INFORMATION: 'Basic information',
      CASE_STATUS: 'Case status',
      CAUSE_OF_REPETITION_FOR_SIMILAR_INCIDENTS:
        'Cause of repetition for similar incidents',
      CONSEQUENCE_OF_REPETITION: 'Consequence of repetition',
      CONSEQUENCES_AND_POSSIBLE_CONSEQUENCES:
        'Consequences and possible consequences',
      CONSEQUENCES_ON_REPETITION: 'Consequences on repetition',
      CORRECTION_AND_SUPPLEMENTATION: 'Correction and supplementation',
      CREATE_DEVIATION_REPORT: 'Create deviation report',
      CREATE_REPORT: 'Create report',
      DATE: 'Date',
      DELETE: 'Delete',
      DELETED: 'Deleted',
      DESCRIPTION_OF_PREVENTION_MEASURES_FOR_SIMILAR_INCIDENTS:
        'Description of Prevention measures for similar incidents (Where, When, How)',
      DESCRIPTION_OF_SUPPORT_NEEDS: 'Description of support needs',
      DEVIATION_REPORT: 'Deviation report',
      DEVIATIONS: 'Deviations',
      EDIT_DEVIATION_REPORT: 'Edit deviation report',
      FAILED_TO_ADD: 'Failed to add',
      FAILED_TO_DELETE: 'Failed to delete',
      FAILED_TO_SAVE: 'Failed to save',
      FAILED_TO_UPDATE: 'Failed to update',
      IMMEDIATE_ACTION: 'Immediate action',
      IMMEDIATE_ACTIONS_TAKEN: 'Immediate actions taken',
      INCIDENT_CAUSES: 'Incident causes',
      INCIDENT_DATE: 'Incident date',
      INCIDENT_LOCATION: 'Incident location',
      INCIDENT_TYPE: 'Incident type',
      INFORMATION_AND_FEEDBACK: 'Information and feedback',
      INFORMATION_SOURCE: 'Information source',
      INVESTIGATION: 'Investigation',
      INVESTIGATION_COMPLETED: 'Investigation completed',
      INVESTIGATION_COMPLETED_BY: 'Investigation completed by',
      INVESTIGATION_COMPLETION_DATE: 'Investigation completion date',
      INVESTIGATION_DESCRIPTION: 'Investigation description',
      INVESTIGATION_DOCUMENTATION_AND_EVENT_DESCRIPTION:
        'Investigation documentation and event description',
      INVESTIGATION_START_DATE: 'Investigation start date',
      INVESTIGATOR: 'Investigator',
      IS_FEEDBACK_INFORMED_TO_AFFECTED_CLIENT_AND_RELATIVE:
        'Is feedback communicated to affected client and relative?',
      IS_FEEDBACK_INFORMED_TO_FOSTER_FAMILY:
        'Is feedback communicated to the effcted foster families?',
      IS_FEEDBACK_INFORMED_TO_IVO:
        'Is feedback communicated to IVO (Inspectorate for Health and Care)?',
      IS_FEEDBACK_INFORMED_TO_MANAGEMENT:
        'Is feedback information communicated to the management?',
      IS_FEEDBACK_INFORMED_TO_RELEVANT_AUTHORITY:
        'Is feedback communicated to the relevant authority?',
      IS_FEEDBACK_INFORMED_TO_RELEVANT_STAFF:
        'Is feedback information communicated to relevant staff?',
      IS_INVESTIGATION_COMPLETED: 'Is the investigation completed',
      JUSTIFICATION_FOR_EVALUATION: 'Justification for evaluation',
      JUSTIFICATION_FOR_IMMEDIATE_ACTION: 'Justification for immediate action',
      LOCATION_DESCRIPTION: 'Location description',
      MAY_AFFECT_QUALITY_OF_OPERATIONS:
        'The incident may affect the quality of operations',
      NEED_OF_SUPPORT: 'Need of support',
      NO: 'No',
      NO_DEVIATION_REPORTS_TO_SHOW: 'There are no deviation reports to show',
      NO_IMMEDIATE_ACTION:
        'There are no immediate actions to show, please add one if needed',
      POSSIBLE_CONSEQUENCES: 'Possible consequences',
      POSSIBLE_CONSEQUENCES_DESCRIPTION: 'Description of possible consequences',
      PREVENTION_MEASURES_FOR_SIMILAR_INCIDENTS:
        'Prevention measures for similar incidents',
      QUALITY_DEFICIENCY_OR_RISK_HAS_BEEN_REMEDIATED:
        'The deficiency in our quality or the risk of deficiency in quality has been remedied',
      REASONS_FOR_REPETITION_OF_SIMILAR_INCIDENTS:
        'Reasons for repetition of similar incidents',
      REPETITION_COMMENT: 'Comment on repetition',
      REPORT: 'Report',
      REPORT_DATE: 'Report date',
      REPORTING_USERS: 'Reporting users',
      RISK_OF_REPETITION: 'Risk of repetition',
      SAVE: 'Save',
      SAVED: 'Saved',
      SEQUENCE_DESCRIPTION: 'Sequence description',
      SEVERITY: 'Severity',
      SHOW_PDF: 'Show PDF',
      SIMILAR_EVENTS: 'Similar events',
      SIMILAR_INCIDENTS_HAVE_OCCURRED: 'Similar incidents have occurred',
      SUMMARY_OF_SIMILAR_INCIDENTS: 'Summary of similar incidents',
      SUPPORT_NEEDED_FOR_CLIENTS: 'Support needed for clients',
      SUPPORT_NEEDED_FOR_STAFF: 'Support needed for staff',
      TYPE: 'Type',
      TYPE_OF_DEVIATION: 'Type of deviation',
      UPDATED: 'Updated',
      WAS_A_DISCREPANCY_OR_SIGNIFICANT_RISK_OF_DISCREPANCY:
        'The incident was a discrepancy or a significant risk of a discrepancy',
      YES: 'Yes',
      YOUR_CHANGES_WILL_BE_IRREVERSIBLE:
        'By proceeding, your changes will be irreversible and cannot be undone.',
    },
    'sv-SE': {
      ACTUAL_CONSEQUENCES: 'Faktiska konsekvenser',
      ACTUAL_CONSEQUENCES_DESCRIPTION: 'Beskrivning av faktiska konsekvenser',
      ADD_MEASURE: 'Lägg till åtgärd',
      ADDED: 'Tillagd',
      AFFECTED_CLIENTS: 'Påverkade klienter',
      AFFECTED_FOSTER_FAMILIES: 'Påverkade familjehem',
      AFFECTED_STAFF: 'Påverkade personal',
      ARE_YOU_SURE_WANT_TO_DELETE: 'Är du säker på att du vill radera?',
      ASSESSMENT: 'Bedömning',
      ASSESSMENT_AND_DECISION: 'Bedömning och beslut om åtgärd',
      ASSESSMENT_OF_INVESTIGATED_REPORT: 'Bedömning av utredd rapport',
      BASIC_INFORMATION: 'Grunduppgifter',
      CASE_STATUS: 'Ärendestatus',
      CAUSE_OF_REPETITION_FOR_SIMILAR_INCIDENTS:
        'Orsak till upprepning av liknande händelser',
      CONSEQUENCE_OF_REPETITION: 'Konsekvens av upprepning',
      CONSEQUENCES_AND_POSSIBLE_CONSEQUENCES:
        'Konsekvenser och möjliga konsekvenser',
      CONSEQUENCES_ON_REPETITION: 'Konsekvenser vid upprepning',
      CORRECTION_AND_SUPPLEMENTATION: 'Korrigering och komplettering',
      CREATE_DEVIATION_REPORT: 'Skapa avvikelsrapport',
      CREATE_REPORT: 'Skapa rapport',
      DATE: 'Datum',
      DELETE: 'Radera',
      DELETED: 'Raderad',
      DESCRIPTION_OF_PREVENTION_MEASURES_FOR_SIMILAR_INCIDENTS:
        'Beskrivning av förebyggande åtgärder för liknande händelser (Var, När, Hur)',
      DESCRIPTION_OF_SUPPORT_NEEDS: 'Beskrivning av stödbehov',
      DEVIATION: 'Avvikelse',
      DEVIATION_REPORT: 'Avvikelsrapport',
      DEVIATIONS: 'Avvikelser',
      EDIT_DEVIATION_REPORT: 'Redigera avvikelsrapport',
      FAILED_TO_ADD: 'Misslyckades att lägga till',
      FAILED_TO_DELETE: 'Misslyckades att radera',
      FAILED_TO_SAVE: 'Misslyckades att spara',
      FAILED_TO_UPDATE: 'Misslyckades att uppdatera',
      IMMEDIATE_ACTION: 'Omedelbar åtgärd',
      IMMEDIATE_ACTIONS_TAKEN: 'Vidtagna omedelbara åtgärder',
      INCIDENT_CAUSES: 'Avvikelseorsaker',
      INCIDENT_DATE: 'Händelsedatum',
      INCIDENT_LOCATION: 'Händelseplats',
      INCIDENT_TYPE: 'Händelsetyp',
      INFORMATION_AND_FEEDBACK: 'Information och återkoppling',
      INFORMATION_SOURCE: 'Informationskälla',
      INVESTIGATION: 'Utredning',
      INVESTIGATION_COMPLETED: 'Utredning slutförd',
      INVESTIGATION_COMPLETED_BY: 'Utredningen avslutad av',
      INVESTIGATION_COMPLETION_DATE: 'Utredningsslutdatum',
      INVESTIGATION_DESCRIPTION: 'Beskrivning av utredningen',
      INVESTIGATION_DOCUMENTATION_AND_EVENT_DESCRIPTION:
        'Utredningsunderlag och händelsebeskrivning',
      INVESTIGATION_START_DATE: 'Utredningsstartdatum',
      INVESTIGATOR: 'Utredningsansvarig',
      IS_FEEDBACK_INFORMED_TO_AFFECTED_CLIENT_AND_RELATIVE:
        'Har återkoppling kommunicerats till berörd klient och anhörig?',
      IS_FEEDBACK_INFORMED_TO_FOSTER_FAMILY:
        'Har återkoppling kommunicerats till påverkade familjehem?',
      IS_FEEDBACK_INFORMED_TO_IVO:
        'Har återkoppling kommunicerats till IVO (Inspektionen för vård och omsorg)?',
      IS_FEEDBACK_INFORMED_TO_MANAGEMENT:
        'Har återkopplingsinformation kommunicerats till ledningen?',
      IS_FEEDBACK_INFORMED_TO_RELEVANT_AUTHORITY:
        'Har återkoppling kommunicerats till berörd myndighet?',
      IS_FEEDBACK_INFORMED_TO_RELEVANT_STAFF:
        'Har återkopplingsinformation kommunicerats till relevant personal?',
      IS_INVESTIGATION_COMPLETED: 'Är utredningen avslutad',
      JUSTIFICATION_FOR_EVALUATION: 'Motivering till bedömning',
      JUSTIFICATION_FOR_IMMEDIATE_ACTION: 'Motivering till omedelbar åtgärd',
      LOCATION_DESCRIPTION: 'Platsbeskrivning',
      MAY_AFFECT_QUALITY_OF_OPERATIONS:
        'Händelsen kan medföra brist i verksamhetens kvalitet',
      NEED_OF_SUPPORT: 'Behov av stöd',
      NO: 'Nej',
      NO_DEVIATION_REPORTS_TO_SHOW:
        'Det finns inga avvikelserapporter att visa',
      NO_IMMEDIATE_ACTION:
        'Det finns inga omedelbara åtgärder att visa, vänligen lägg till en om det behövs',
      POSSIBLE_CONSEQUENCES: 'Möjliga konsekvenser',
      POSSIBLE_CONSEQUENCES_DESCRIPTION: 'Beskrivning av möjliga konsekvenser',
      PREVENTION_MEASURES_FOR_SIMILAR_INCIDENTS:
        'Förebyggande åtgärder för liknande händelser',
      QUALITY_DEFICIENCY_OR_RISK_HAS_BEEN_REMEDIATED:
        'Bristen i vår kvalitet eller risken för brist i kvalitet är avhjälpt',
      REASONS_FOR_REPETITION_OF_SIMILAR_INCIDENTS:
        'Skäl till upprepning av liknande händelser',
      REPETITION_COMMENT: 'Kommentar om upprepning',
      REPORT: 'Rapport',
      REPORT_DATE: 'Rapportdatum',
      REPORTING_USERS: 'Rapporterande användare',
      RISK_OF_REPETITION: 'Risk för upprepning',
      SAVE: 'Spara',
      SAVED: 'Sparad',
      SEQUENCE_DESCRIPTION: 'Sekvensbeskrivning',
      SEVERITY: 'Allvarlighetsgrad',
      SHOW_PDF: 'Visa PDF',
      SIMILAR_EVENTS: 'Liknande händelser',
      SIMILAR_INCIDENTS_HAVE_OCCURRED:
        'Liknande händelser har inträffat tidigare',
      SUMMARY_OF_SIMILAR_INCIDENTS:
        'Sammanfattning av tidigare liknande händelser',
      SUPPORT_NEEDED_FOR_CLIENTS: 'Behov av stöd för klienter',
      SUPPORT_NEEDED_FOR_STAFF: 'Behov av stöd för personal',
      TYPE: 'Typ',
      TYPE_OF_DEVIATION: 'Typ av avvikande händelse',
      UPDATED: 'Uppdaterad',
      WAS_A_DISCREPANCY_OR_SIGNIFICANT_RISK_OF_DISCREPANCY:
        'Händelsen var ett missförhållande eller en påtaglig risk för ett missförhållande',
      YES: 'Ja',
      YOUR_CHANGES_WILL_BE_IRREVERSIBLE:
        'Dina ändringar kommer att vara oåterkalleliga och kan inte ångras',
    },
  },
};
